export default __webpack_public_path__ + "static/media/rr5.2aa0588d.jpg";